import { Component, OnInit, OnDestroy, ViewEncapsulation, Input, AfterViewChecked, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { Observable, Subscription, Subject } from 'rxjs';

import { SignalRChannelService } from './services/signalrchannel.service';
import { CookieService } from './services/cookie.service';
import { Bot } from './models/bot.model';
import { Message, UxItem, Attachment, SubscribeResponse, BotVisuals, Appointment } from './models/chatstyle.model';

import './core/prototypes/prototypes';

import { DeviceDetectorService } from 'ngx-device-detector';
import { NgxSpinnerService } from "ngx-spinner";
import * as moment_ from 'moment';
const moment = moment_;

import {
  trigger,
  state,
  style,
  animate,
  transition,
  // ...
} from '@angular/animations';


@Component({
  selector: 'chatstyleai-chatbox',
  templateUrl: './chatstyleai-chatbox.component.html',
  styleUrls: ['./chatstyleai-chatbox.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  animations: [
    trigger('openCloseChat', [
      state('open', style({
        //height: window.innerHeight,
        opacity: 1,
      })),
      state('closed', style({
        //height: '100px',
        opacity: 0.0
      })),
      transition('open => closed', [
        animate('0.25s')
      ]),
      transition('closed => open', [
        animate('0.25s')
      ]),
    ]),
    trigger('connection', [
      state('active', style({
        opacity: 1,
      })),
      state('inactive', style({
        opacity: 100.0
      })),
      transition('open => closed', [
        animate('0.25s')
      ]),
      transition('closed => open', [
        animate('0.25s')
      ]),
    ])
  ]
})
export class ChatstyleaiChatboxComponent implements OnInit, OnDestroy, AfterViewChecked {

  @ViewChild('historyScroll') private historyScroll: ElementRef;
  @ViewChild('messageInput') private messageInput: ElementRef;
  @ViewChild('fileUpload') private fileUpload: ElementRef;
  @ViewChild('chatbox') private chatbox: ElementRef;
  @ViewChild('chatboxbutton') private chatboxbutton: ElementRef;

  public isOpen: boolean;
  public isApp: boolean;
  public loadHistory: boolean;
  public autoStart: boolean;
  public debugMode: boolean;
  public createNew: boolean;
  public saveAudience: boolean;
  public authRequired: boolean;
  public environment: string; // environment

  public lastErrorText: string;

  public prompt: string;
  public promptMode: string;
  public restarting: boolean;
  public sending: boolean;

  public freeform: boolean;
  public override: boolean;
  public botResponded: boolean;
  public chatOptions: string;

  public allowAttachments: boolean;
  public allowReset: boolean;
  public allowScreenshot: boolean;
  public screenshotCapable: boolean;
  public allowNotifications: boolean;

  public showPop: boolean;
  public bubbleXPos: string;
  public bubbleYPos: string;
  public buttonXPos: string;
  public buttonYPos: string;
  public windowXPos: string;
  public windowYPos: string;
  public windowHeightVal: string;
  protected messageReceived: Subscription;
  protected subscribed: Subscription;
  protected stateChanged: Subscription;
  public audienceID: string;
  protected conversationID: string;
  public isPopup: boolean;

  public fileToUpload: string;

  public uiMode: string;
  public expandedMode: boolean;

  public bot: Bot;
  public newMessage: Message;
  public outMessage: Message;
  public messages: Message[];

  public countdownTo: Date;
  protected currentCountdown: any;

  public botID: string;
  public userID: string;
  protected botVersion: string;
  public botOptions: any;
  public isMobile: boolean;
  public isMobileSmall: boolean;
  public boxZ: string;
  public authDetails: any;

  public visuals: BotVisuals;

  protected messageAdded: boolean;

  public resizeObservable: Observable<Event>;
  public resizeSubscription: Subscription;

  public emptyId: string;

  public isVisible: boolean;

  public dateValue: Date;
  //public calendarPlugins = [listPlugin, bootstrapPlugin]; // important!
  public calendarHeader = {
    left: 'prev,next',
    center: 'title',
    right: 'cancelButton'
  };
  public calendarButtons = {
    cancelButton: {
      text: 'Cancel',
      click: (info) => this.eventListCancel(info)
    }
  };
  public eventData;
  private readonly _destroying$ = new Subject<void>();
  private chime = new Audio();
  private audioData: string;
  private notifyMessage: string;
  private documentTitle: string;
  private notifyNewMessage: boolean;
  private notifyBlinkInterval;
  private notifyChimeInterval;

  @Input()
  set env(val: string) {
    this.environment = val;
  }

  @Input()
  set showButton(val: boolean) {
    this.isVisible = val;
  }

  @Input()
  set buttonY(val: string) {
    this.buttonYPos = val;
  }

  @Input()
  set windowY(val: string) {
    this.windowYPos = val;
  }

  @Input()
  set buttonX(val: string) {
    this.buttonXPos = val;
  }

  @Input()
  set windowX(val: string) {
    this.windowXPos = val;
  }

  @Input()
  set windowHeight(val: string) {
    this.windowHeightVal = val;
  }

  @Input()
  set open(val: boolean) {
    this.isOpen = val;
  }

  @Input()
  set channel(val: string) {
    this.botID = val;
  }

  @Input()
  set user(val: string) {
    this.userID = val;
  }

  @Input()
  set version(val: string) {
    this.botVersion = val;
  }

  @Input()
  set options(val: string) {
    this.botOptions = JSON.parse(val);
  }

  @Input()
  set userInfo(val: any) {
    this.authDetails = val;
    if (this.authDetails && this.authRequired === true) {

      this.signalr.init(this.audienceID, this.botID, this.botVersion, this.loadHistory, this.autoStart, this.debugMode,
        this.createNew, this.environment, this.authDetails);

    }
  }

  @Input()
  set mode(val: string) {
    this.uiMode = val;
    this.updateMode();
  }


  constructor(
    public renderer: Renderer2,
    private signalr: SignalRChannelService,
    public elementRef: ElementRef,
    private deviceService: DeviceDetectorService,
    private cookie: CookieService,
    private spinner: NgxSpinnerService
  ) {
    console.log('chatbox.v2.0.20241110');

    this.prompt = null;
    this.promptMode = null;
    this.restarting = false;
    this.sending = false;
    this.freeform = false;
    this.botResponded = false;
    this.boxZ = "2147483647 !important";

    this.uiMode = '';
    this.expandedMode = false;

    this.countdownTo = null;
    this.currentCountdown = null;

    this.isVisible = true;
    this.emptyId = '00000000-0000-0000-0000-000000000000';
    this.fileToUpload = null;

    this.botOptions = {};
    this.isOpen = false;
    this.isApp = false;
    this.isMobile = false;
    this.isMobileSmall = false;
    this.showPop = false;
    this.loadHistory = true;
    this.messageAdded = false;
    this.autoStart = false;
    this.debugMode = false;
    this.createNew = false;
    this.saveAudience = true;
    this.authRequired = false;
    this.isPopup = false;
    this.allowScreenshot = false;
    this.allowNotifications = false;

    this.bubbleXPos = "80px";
    this.bubbleYPos = "80px";
    this.buttonXPos = "40px";
    this.buttonYPos = "40px";
    this.windowXPos = "20px";
    this.windowYPos = "50px";
    this.windowHeightVal = "85vh";

    this.lastErrorText = null;

    this.messages = [];

    this.documentTitle = '';
    this.notifyMessage = '';

    this.audioData = 'data:audio/ogg;base64,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';
    this.chime = new Audio();

    this.notifyNewMessage = false;
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        this.endNotifications();
      }
    });

    this.notifyBlinkInterval = setInterval(() => {
      if ((document.hidden || !this.isOpen) && this.notifyNewMessage) {
        document.title = document.title == this.documentTitle ?
          (this.documentTitle + this.notifyMessage) : this.documentTitle;
      }
    }, 2000);

    this.notifyChimeInterval = setInterval(() => {
      if ((document.hidden || !this.isOpen) && this.notifyNewMessage) {
        this.chime.play();
      }
    }, 10000);

    this.messageReceived = signalr.MessageReceived.subscribe((message) => {

      // recalculate bubble position
      this.bubbleXPos = parseInt(this.buttonXPos, 10) + 40 + "px";
      this.bubbleYPos = parseInt(this.buttonYPos, 10) + 40 + "px";

      // new message means no countdown
      this.countdownTo = null;
      clearTimeout(this.currentCountdown);

      console.log(message);
      this.lastErrorText = null;
      if (message.payload === 'conversation.reset') {
        this.messages = [];
        return;
      }

      if (message.payload === 'conversation.closed') {
        this.promptClosed();
        this.clearAttachment();
        return;
      }

      if (message.payload === 'conversation.override') {
        this.freeform = true;
        this.override = true;
        //console.log('override is true');
        return;
      }

      if (message.payload === 'conversation.returntobot') {
        this.freeform = false;
        this.override = false;
        //console.log('override is false');
        return;
      }

      if (message.payload === 'message.expired') {
        return;
      }

      if (message.payload === 'auth.signin') {
        this.freeform = false;
        this.override = false;
        this.loginPopup(message);
        return;
      }

      if (message.payload === 'url') {

        this.showUrl(message);

        return;
      }


      if (message.payload === 'conversation.idupdate') {
        console.log('updating service ids from server');
        this.conversationID = message.conversationID;
        this.audienceID = message.recipientID;
        this.signalr.updateIds(this.conversationID, this.audienceID);
        this.cookie.setSafeSiteCookie("chatstyleai-audience", this.audienceID, 365);
        return;
      }

      // strip out any previous typing messages
      for (const msg of this.messages) {
        if (msg.payload === 'message.typing') {
          this.messages.splice(this.messages.indexOf(msg), 1);
        }
      }

      if (message.payload === 'message.typing') {
        this.messages.push(message);
        this.messageAdded = true;
        return;
      }

      // the last message needs to be from the bot to input freely
      this.botResponded = (message.senderID !== this.audienceID);

      // No text and not one of the expected payloads, ignore
      if (!message.text &&
        (!message.attachments || message.attachments.length === 0)) {
        if (!message.uxItems || message.uxItems.length === 0) {
          return;
        } else {
          let hasButtons = false;
          for (let ux of message.uxItems) {
            if (ux.type === 'button') {
              hasButtons = true;
            }
          }

          // For now, only buttons can be displayed
          if (!hasButtons) {
            return;
          }
        }
      }

      if (message.text) {
        this.notify('- *New message*');
      }

      this.newMessage.text = message.text;
      this.newMessage.blockInput = message.blockInput;
      this.newMessage.blockAttachments = message.blockAttachments;
      this.newMessage.inputType = message.inputType;
      this.newMessage.payload = message.payload;

      if (this.newMessage.blockInput === true) {
        this.outMessage.text = '';
        this.dateValue = null;
      }

      if (this.newMessage.inputType) {
        switch (this.newMessage.inputType) {
          case 'eventlist': {
            this.eventData = JSON.parse(this.newMessage.payload); // this.loadEventDataFromAppointments(); //.loadEventData();
          }
          break;

          default: {
            this.eventData = null;
          }
          break;
        }
      }

      if (message.ttl) {
        let now = new Date();
        let bump = parseInt(message.ttl) * 1000;
        now.setTime(now.getTime() + bump);
        this.countdownTo = now;
        this.currentCountdown = setTimeout(() => {
            if (this.countdownTo) {
              //console.log('countdown fired');
              clearTimeout(this.currentCountdown);
              this.countdownTo = null;
              this.sendExpired();
            }
            //console.log('countdown ignored');
        }, bump); 
      }

      this.messages.push(message);

      this.messageAdded = true;
      this.popupMessage();
    });


    this.stateChanged = signalr.StateChanged.subscribe((state) => {

      if (state !== 'connected') {
        this.spinner.show();
      } else {
        this.restarting = false;
        this.spinner.hide();
      }

    });

    this.subscribed = signalr.Subscribed.subscribe((response) => {
      //console.log(response);
      this.lastErrorText = null;
      this.conversationID = response.conversationID;

      this.chatOptions = response.options;

      this.freeform = true;
      this.override = false;
      this.allowAttachments = true;
      this.allowReset = true;
      this.screenshotCapable = true;

      if (this.chatOptions && this.chatOptions.includes('waitforbot')) {
        this.freeform = false;
      }

      if (this.chatOptions && this.chatOptions.includes('ispopup')) {
        this.isPopup = true;
      }

      if (this.chatOptions && this.chatOptions.includes('screenshot')) {
        this.allowScreenshot = true;
      }

      if (this.chatOptions && this.chatOptions.includes('notifications')) {
        this.allowNotifications = true;
      }

      if (this.chatOptions && this.chatOptions.includes('blockattachments')) {
        this.allowAttachments = false;
      }

      if (this.chatOptions && this.chatOptions.includes('blockreset')) {
        this.allowReset = false;
      }

      if (response.status === 'override') {
        this.freeform = true;
        this.override = true;
        //console.log('override is true');
      }

      if (this.signalr.tag) {
        // if we start mid conversation, open up
        this.isOpen = true;
      }

      if (this.conversationID !== this.emptyId) {

        this.audienceID = response.audienceID;
        this.cookie.setSafeSiteCookie("chatstyleai-audience", this.audienceID, 365);

        this.visuals = response.visuals;

        this.bot = {
          botID: response.botID,
          name: response.visuals.label,
          imageUrl: response.visuals.imageUrl,
          description: '',
          active: true,
          audienceCount: 0
        };

        if (response.messages && response.messages.length > 0) {
          this.messages = response.messages.reverse();
          this.messages.forEach((msg) => {
            if (msg.channel !== 'signalr') {
              if (!msg.fromDisplayName) {
                msg.senderID = this.audienceID;
              }
            }
          });
          this.messageAdded = true;

          let lastMsg = this.messages[response.messages.length - 1];

          // the last message needs to be from the bot to input freely
          this.botResponded = (lastMsg.senderID !== this.audienceID);

        }

        this.scrollToBottom();
      }
    });
  }

  loginSuccess(): void {
    //console.log('loginSuccess');
  }

  updateMode(): void {
    switch (this.uiMode) {
      case 'expanded': {
        this.expandedMode = true;
        this.isOpen = this.showButton;
      }
        break;

      default: {
        this.expandedMode = false;
      }
        break;
    }
  }

  getz(): string {
    if (this.isOpen) {
      return this.boxZ;
    } else {
      return "-1 !important";
    }
  }
  getCountdownColor(time): string {
    // time since message was sent in seconds
    let now = new Date().getTime();
    let delta = (time.getTime() - now) / 1000;
    delta = Math.round(delta);

    // format string
    if (delta < 10) {
      return 'red';
    }
    else if (delta < 60) { // sent in last minute
      return 'black';
    }
    return 'black';
  }

  getCountdownTextShadow(time): string {
    // time since message was sent in seconds
    let now = new Date().getTime();
    let delta = (time.getTime() - now) / 1000;
    delta = Math.round(delta);

    // format string
    if (delta < 10) {
      return '';
    }
    else if (delta < 60) { // sent in last minute
      return '1px 1px yellow';
    }
    return '';
  }

  canSend(): boolean {
    if (this.sending === true) {
      return false;
    }
    if (this.bot && this.isOpen) {
      if (this.conversationID) {
        if (this.newMessage && this.newMessage.blockInput) {
          return false;
        }
        if (this.prompt) {
          return false;
        }
        if (this.outMessage.text || this.dateValue || this.fileToUpload) {
          if (this.outMessage.text === 'Invalid date' && this.newMessage && this.newMessage.inputType === 'date') {
            return false;
          }
          return true;
        }
      }
    }
    return false;
  }

  canUpload(): boolean {
    if (this.sending === true) {
      return false;
    }
    if (this.fileToUpload !== null) {
      return false;
    }
    // if you cant send why upload?
    if (this.bot && this.isOpen) {
      if (this.conversationID) {
        if (this.blockInput()) {
          return false;
        }
        if (this.newMessage && this.newMessage.blockAttachments) {
          return false;
        }
        if (this.prompt) {
          return false;
        }
        if (this.allowAttachments === false) {
          return false;
        }
        return true;
      }
    }
    return false;
  }

  canRestart(): boolean {
    if (this.bot) {
      if (this.conversationID) {
        if (this.prompt) {
          return false;
        }
        return true;
      }
    }
    return false;
  }

  canScreenshot(): boolean {
    return this.allowScreenshot && this.canUpload();
  }

  getPlaceholder(): string {
    if (this.freeform === true) {
      return "Type your message";
    }
    if (this.botResponded === false) {
      return '';
    }
    if (this.newMessage && this.newMessage.blockInput) {
      return "Choose an option";
    }
    return "Type your message";
  }

  getStyles(message): any {
    let cursor = 'pointer';
    if (this.prompt) {
      cursor = 'default';
    }
    let style = {
      background: '#FFFFFF',
      cursor: cursor,
      borderColor: this.visuals.primaryColor,
      color: this.visuals.primaryColor //this.visuals.secondaryColor
    };
    if (message) {
      style.cursor = 'default';
      if (message.senderID !== this.audienceID) {
        style.background = this.visuals.primaryColor; //this.visuals.secondaryColor;
        style.color = '#FFFFFF';
        style.cursor = 'default';
        style.borderColor = this.visuals.secondaryColor;
      }
    }
    return style;
  }

  connected(): boolean {
    if (this.signalr) {
      if (this.signalr.connectionState === 'connected') {
        return true;
      }
    }

    return false;
  }

  connectionMessage(): string {
    if (this.signalr) {
      if (this.signalr.connectionState === 'reconnecting') {
        return 'Reconnecting...';
      }
      if (this.signalr.connectionState === 'disconnected') {
        if (this.restarting) {
          return 'Restarting...';
        }
        return 'We lost the connection. Click here to reconnect.';
      }
    }

    return '';
  }

  emptyMessage(): Message {

    return {
      attachments: [],
      body: "",
      channel: "signalr",
      conversationID: this.conversationID,
      recipientID: this.botID,
      senderID: this.audienceID,
      payload: "",
      text: "",
      time: new Date(),
      uxItems: [],
      fromDisplayName: '',
      toDisplayName: '',
      tag: '',
      info: '',
      blockInput: false,
      inputType: '',
      ttl: '',
      blockAttachments: false,
      data: '',
      isCommand: false
    };
  }

  popupMessage() {
    if (this.isOpen === false) {
      this.showPop = true;

      setTimeout(() => {
        this.showPop = false;
      }, 10000);
    }

  };


  scrollToBottom() {
    try {
      this.historyScroll.nativeElement.scrollTop = this.historyScroll.nativeElement.scrollHeight;
    } catch (err) { }
  }

  onPaste(event: any) {
    let cbevt = event;
    //console.log(cbevt);
    //console.log(this.fileUpload);
    //let data = cbevt.clipboardData.getData('image');
    //console.log(data);
    if (event.clipboardData && event.clipboardData.files && event.clipboardData.files.length > 0) {
      this.fileUpload.nativeElement.files = event.clipboardData.files;
      this.fileToUpload = 'x ' + event.clipboardData.files[0].name;
    }
  }

  ngOnInit() {

    if (this.userID) {
      this.audienceID = this.userID;
    } else {
      this.audienceID = this.cookie.getCookie("chatstyleai-audience");
      if (!this.audienceID) {
        this.audienceID = '';
      }
    }

    //if (!this.audienceID) {

    //  this.audienceID = "123456";

    //}
    window.addEventListener('paste', e => { this.onPaste(e); } );

    this.outMessage = this.emptyMessage();
    this.newMessage = this.emptyMessage();

    this.isMobile = this.deviceService.isMobile();
    if (this.botOptions.mobileSize) {
      this.isMobileSmall = this.isMobile && this.botOptions.mobileSize === 'small';
    }

    if (this.botOptions.isOpen) {
      this.isOpen = this.botOptions.isOpen === "true" ? true : false;
      //this.messageInput.nativeElement.focus();
    }

    if (this.botOptions.isApp) {
      this.isApp = this.botOptions.isApp === "true" ? true : false;
    }

    if (this.isApp === true) {
      this.isMobile = true;
      this.isOpen = true;
    }

    // we cant start open on mobile it covers everything, except when running in the app
    if (this.isMobile === true && this.isApp === false) {
      this.isOpen = false;
    }

    if (this.botOptions.isVisible) {
      this.isVisible = this.botOptions.isVisible === "true" ? true : false;
      //this.messageInput.nativeElement.focus();
    }


    if (this.botOptions.loadHistory) {
      this.loadHistory = this.botOptions.loadHistory === "false" ? false : true;
    }

    if (this.botOptions.autoStart) {
      this.autoStart = this.botOptions.autoStart === "true" ? true : false;
    }

    if (this.botOptions.debugMode) {
      this.debugMode = this.botOptions.debugMode === "true" ? true : false;
    }

    if (this.botOptions.createNew) {
      this.createNew = this.botOptions.createNew === "true" ? true : false;
    }

    if (this.botOptions.saveAudience) {
      this.saveAudience = this.botOptions.saveAudience === "false" ? false : true;
    }

    if (this.botOptions.authRequired) {
      this.authRequired = this.botOptions.authRequired === "true" ? true : false;
    }

    if (this.botOptions.isPopup) {
      this.isPopup = this.botOptions.isPopup === "true" ? true : false;
    }

    if (this.botOptions.allowScreenshot) {
      this.allowScreenshot = this.botOptions.allowScreenshot === "true" ? true : false;
    }

    if (this.botOptions.allowNotifications) {
      this.allowNotifications = this.botOptions.allowNotifications === "true" ? true : false;
    }

    if (this.saveAudience === false) {
      this.audienceID = '';
    }

    this.cookie.setSafeSiteCookie("chatstyleai-audience", this.audienceID, 365);

    if (this.botOptions.zindex) {
      this.boxZ = this.botOptions.zindex + " !important";
    }

    if (this.botOptions.env) {
      this.environment = this.botOptions.env;
    } else {
      this.environment = 'production';
    }


    let paramsString = window.location.search;
    let searchParams = new URLSearchParams(paramsString);

    if (searchParams.has("cvx")) {
      this.isOpen = true;
    }

    if (this.authRequired === false) {
      this.signalr.init(this.audienceID, this.botID, this.botVersion, this.loadHistory, this.autoStart, this.debugMode,
        this.createNew, this.environment, null);
    }

    //if (window.innerWidth < 980) {
    //  this.isMobile = true;
    //}

}


  ngOnDestroy() {

    this.messageReceived.unsubscribe();
    this._destroying$.next(null);
    this._destroying$.complete();
  }

  ngAfterViewChecked() {

    //if (this.isOpen) {
    //  if (this.messageInput) {
    //    if (!this.isMobile) {
    //      this.messageInput.nativeElement.focus();
    //    }
    //  }
    //}

    if (this.messageAdded) {
      this.messageAdded = false;
      this.scrollToBottom();
    }
  }

  toggleChat() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.endNotifications();
      this.showPop = false;
      this.messageInput.nativeElement.scrollIntoView();
      //if (this.isMobile) {
      //  window.scrollTo(0, document.body.scrollHeight);
      //}
      if (this.messageInput && !this.isMobile) {
        this.messageInput.nativeElement.focus();
      }
    }
  }

  reconnect() {
    this.doRestart();
  }

  send() {
    if (!this.canSend()) {
      return;
    }

    this.sending = true;

    if (this.fileToUpload) {
      return this.sendAttachment();
    }

    var msg: Message = this.emptyMessage();

    var text = this.outMessage.text;
    text = text.trim();

    if (text && text.length > 0) {

      msg.text = text;
      msg.time = new Date();
      msg.payload = this.outMessage.payload;

      //console.log(msg);

      var promise = this.signalr.sendMessage(msg);

      promise.then(cfg => {
        this.sending = false;
        this.lastErrorText = null;
        this.outMessage.text = '';
        this.outMessage.payload = '';
        this.dateValue = null;
        if (!this.isMobile) {
          this.messageInput.nativeElement.focus();
        }
        //console.log(cfg);
      })
        .catch((a) => {
          //console.log('error sending ' + a);
          this.sending = false;
          this.lastErrorText = "Failed to send";
        });
    }



  }


  sendExpired() {

    var msg: Message = this.emptyMessage();
    msg.time = new Date();
    msg.payload = "message.expired";

    var promise = this.signalr.sendMessage(msg);

    promise.then(cfg => {
      this.lastErrorText = null;
      this.outMessage.text = '';
      this.outMessage.payload = '';
      this.dateValue = null;
      if (!this.isMobile) {
        this.messageInput.nativeElement.focus();
      }
      //console.log(cfg);
    })
      .catch((a) => {
        //console.log('error sending ' + a);
        this.lastErrorText = "Failed to send";
      });

  }


  sendOption(item: UxItem) {
    if (item.url) {
      window.open(item.url, '_blank').focus();
      return;
    }
    this.sending = true;
    var msg: Message = this.emptyMessage();

    msg.text = item.label;
    msg.payload = item.value;
    if (item.data) {
      msg.data = item.data;
      msg.isCommand = true;
    }

    //console.log(msg);

    var promise = this.signalr.sendMessage(msg);

    promise.then(cfg => {
      this.sending = false;
      this.lastErrorText = null;
      this.outMessage.text = '';
      this.dateValue = null;
      if (!this.isMobile) {
        this.messageInput.nativeElement.focus();
      }
      //console.log(cfg);
    })
      .catch((a) => {
        //console.log('error sending ' + a);
        this.sending = false;
        this.lastErrorText = "Failed to send";
      });
  }

  sendAttachment() {

    let msg: Message = this.emptyMessage();

    msg.text = this.outMessage.text;
    msg.time = new Date();

    //console.log(msg);

    let formData = new FormData();
    let uploadFile = true;

    formData.append('message', JSON.stringify(msg));

    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll('.chatbox-upload');
    //console.log(elements);
    for (let i = 0; i < elements.length; i++) {
      const fe = elements[i] as HTMLInputElement;
      if (fe && fe.files && fe.files.length > 0) {
        if (fe.files[0].size > 10485760) {
          //console.log('file too large');
          this.lastErrorText = 'File too large';
          uploadFile = false;
        } else {
          formData.append(fe.id, fe.files[0]);
        }
      }
    }

    if (uploadFile) {
      var promise = this.signalr.sendMessageEx(formData);
      promise.then(cfg => {
        this.sending = false;
        this.lastErrorText = null;
        this.outMessage.text = '';
        if (this.fileUpload) {
          this.fileUpload.nativeElement.value = null;
        }

        if (!this.isMobile) {
          this.messageInput.nativeElement.focus();
        }
        this.fileToUpload = null;
        //console.log(cfg);
      })
        .catch((a) => {
          //console.log('error sending ' + a);
          this.sending = false;
          this.lastErrorText = "Failed to send";
        });
    }


  }


  uploadChange() {
    //console.log(this.fileUpload.nativeElement);
    //console.log(this.fileUpload.nativeElement.value);
    let path = null;
    if (this.fileUpload.nativeElement && this.fileUpload.nativeElement.value) {
      const pos = this.fileUpload.nativeElement.value.lastIndexOf('\\') + 1;
      path = this.fileUpload.nativeElement.value.toString().substring(pos);
    }
    this.fileToUpload = 'x ' + path;
  }

  getAttachment(att) {
    //console.log(att);
    this.signalr.downloadAttachment(att);

  }

  clearAttachment() {
    this.fileToUpload = null;

    if (this.fileUpload) {
      this.fileUpload.nativeElement.value = null;
    }
  }

  addAttachment() {
    if (this.canUpload()) {
      this.fileUpload.nativeElement.click();
    }
  }

  restart() {
    if (this.canRestart()) {
      this.prompt = 'Would you like to restart the conversation?';
      this.promptMode = 'restart';
    }
  }

  async screenshot() {
    if (this.canScreenshot()) {

      const opts = { audio: false, video: true };
      const mediaDevices = navigator.mediaDevices as any;

      const stream = await mediaDevices.getDisplayMedia(opts);

      const track = stream.getVideoTracks()[0];

      const imageCapture = new (window as any).ImageCapture(track);
      const bitmap = await imageCapture.grabFrame();
      track.stop();

      const canvas = <HTMLCanvasElement>document.getElementById('ec');
      // this could be a document.createElement('canvas') if you want
      // draw weird image type to canvas so we can get a useful image
      canvas.width = bitmap.width;
      canvas.height = bitmap.height;
      const context = canvas.getContext('2d');
      context.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height);
      const image = canvas.toDataURL();

      // this turns the base 64 string to a [File] object
      const res = await fetch(image);
      const buff = await res.arrayBuffer();
      const fname = 'Screenshot_' + new Date().YYYYMMDDHHMMSS() + '.png';
      // clone so we can rename, and put into array for easy proccessing
      const file = [
        new File([buff], fname, {
          type: 'image/png',
        }),
      ];
      let list = new DataTransfer();
      list.items.add(file[0]);

      this.fileUpload.nativeElement.files = list.files;
      this.fileToUpload = 'x ' + fname;
    }
  }

  promptClosed() {
    this.prompt = 'The conversation has ended. Want to restart?';
    this.promptMode = 'closed';
  }

  promptOk(text) {
    this.prompt = text;
    this.promptMode = 'ok';
  }

  blockInput(): boolean {
    if (this.override === true) {
      return false;
    }
    if (this.freeform === true) {
      return false;
    }
    if (this.botResponded === false) {
      return true;
    }
    if (this.restarting === true) {
      return true;
    }
    if (this.newMessage && this.newMessage.blockInput) {
      return this.newMessage.blockInput;
    }
    return false;
  }

  getInputType(): string {
    if (this.newMessage && this.newMessage.inputType) {
      if (this.newMessage.inputType === 'numbers') {
        return 'text';
      }
      return this.newMessage.inputType;
    }
    return 'text';
  }

  onDateValueChange(value: Date): void {
    this.dateValue = value;

    if (value) {
      this.outMessage.text = moment(value).format("MM-DD-YYYY");
    } else {
      this.outMessage.text = '';
    }
  }

  eventSelect(): void {
    //console.log('Show event selector');
  }

  handleEventClick(info): void {
    //console.log(info.event.id);
    this.outMessage.text = 'I would like ' + moment(info.event.start).format("MM-DD-YYYY hh:mm A"); 
    this.outMessage.payload = info.event.id;
    this.send();
  }

  eventListCancel(info): void {
    //console.log(info);
    this.outMessage.text = "Cancelling...";
    this.outMessage.payload = "cancel";
    this.send();
  }

  getEvents(): any {
    let eventdata = [
      { id: '111', title: 'event 1', start: '2022-07-06 13:00' },
      { id: '222', title: 'event 2', start: '2022-07-09 11:00' }
    ];
    return eventdata;
  }


  getEventInitialDate(): Date {
    return new Date();
  }

  getFileToUpload(): string {
    if (this.fileToUpload) {
      //image-20220523-203615.png
      const parts = this.fileToUpload.split('.');
      if (parts.length === 2) {
        let name: string = parts[0];
        if (name.length > 20) {
          name = name.substring(0, 17) + '...';
          return name + '.' + parts[1];
        } else {
          return this.fileToUpload;
        }
      } else {
        if (this.fileToUpload.length > 20) {
          return this.fileToUpload.substring(0,17) + '...';
        } else {
          return this.fileToUpload;
        }
      }
    }
    return '';
  }

  answerPrompt(answer) {
    switch (this.promptMode) {
      case 'closed':
        {
          if (answer === 'yes') {
            this.prompt = null;
            this.promptMode = null;
            this.messages = [];
            this.restarting = true;
            this.clearAttachment();

            this.audienceID = '';
            //this.authDetails = null;
            this.cookie.setSafeSiteCookie("chatstyleai-audience", this.audienceID, 365);

            if (this.authRequired === false || this.authDetails) {
              this.signalr.init(this.audienceID, this.botID, this.botVersion, this.loadHistory, this.autoStart, this.debugMode,
                this.createNew, this.environment, this.authDetails);
            } else {
              window.location.reload();
            }
          }
          if (answer === 'no') {
            this.isOpen = false;
          }
        }
        break;

      case 'ok':
        {
          this.prompt = null;
          this.promptMode = null;
        }
        break;

      case 'restart':
      default:
        {
          this.prompt = null;
          this.promptMode = null;
          if (answer === 'yes') {
            this.doRestart();
          }
        }
        break;
    }

  }

  doRestart() {
    this.messages = [];
    this.restarting = true;
    this.clearAttachment();

    this.audienceID = '';
    //this.authDetails = null;
    this.cookie.setSafeSiteCookie("chatstyleai-audience", this.audienceID, 365);

    if (this.authRequired === false || this.authDetails) {
      this.signalr.init(this.audienceID, this.botID, this.botVersion, this.loadHistory, this.autoStart, this.debugMode,
        this.createNew, this.environment, this.authDetails);
    } else {
      window.location.reload();
    }
  }

  loginPopup(message) {

    var msgData = JSON.parse(message.data);
    var url = msgData.url;

    var win = this.popup(url, "ChatStyle", 500, 400);
    if (!win) {
      this.promptOk('Sign in blocked, you may need to allow popups.');
    } else {
      win.document.body.innerHTML = "HTML";
    }

  }

  showUrl(message) {

    var msgData = JSON.parse(message.data);
    var url = msgData.url;
    var hash = msgData.hash;
    var target = msgData.target;
    var method = msgData.method;
    var focus = msgData.focus;

    if (url) {

      if (hash) {
        url = url + '#' + hash;
      }

      switch (method) {

        case 'open':
          {
            var win = window.open(url, target);
            if (focus) {
              win.focus();
            }
          }
          break;

        default:
          {

            window.location = url;
          }
          break;
      }

    } else {
      if (hash) {
        location.hash = '#' + hash;
      }
    }

  }

  popup(url, title, width, height) {
    var left = (screen.width - width) / 2;
    var top = (screen.height - height) / 4;

    var win = window.open(url, title,
      'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes, ' +
      'width = ' + width + ', height=' + height + ', top=' + top + ', left=' + left);
    return win;
  }

  notify(message) {
    if (this.allowNotifications === false) {
      return;
    }

    if (this.notifyNewMessage) {
      document.title = this.documentTitle;
    }

    if (document.hidden || !this.isOpen) {
      this.notifyMessage = message;
      this.notifyNewMessage = true;
      this.documentTitle = document.title;

      this.chime.src = this.audioData;
      clearInterval(this.notifyChimeInterval);
      this.chime.play();

      this.notifyChimeInterval = setInterval(() => {
        if ((document.hidden || !this.isOpen) && this.notifyNewMessage) {
          this.chime.play();
        }
      }, 10000);
    }
  }

  endNotifications() {
    this.notifyNewMessage = false;
    if (this.documentTitle) {
      document.title = this.documentTitle;
    }
  }


}
